import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const paginationModel = { page: 0, pageSize: 10 };

export default function DataTable({
  headers,
  data,
  hiddenColumns = [],
  autoRowHeight = false,
  checkboxSelection = false,
  handleOnRowSelectionChanged,
}) {
  const columnVisibilityModel = hiddenColumns.reduce((acc, field) => {
    acc[field] = false;
    return acc;
  }, {});

  return (
    <Paper sx={{ height: "100%", width: "100%" }}>
      <DataGrid
        rows={data}
        columns={headers}
        getRowHeight={autoRowHeight ? () => "auto" : undefined}
        initialState={{
          pagination: { paginationModel },
          columns: { columnVisibilityModel },
        }}
        onRowSelectionModelChange={(id) => {
          handleOnRowSelectionChanged?.(id);
        }}
        checkboxSelection={checkboxSelection}
        disableMultipleRowSelection
        pageSizeOptions={[10, 25, 50]}
        sx={{ border: 0 }}
      />
    </Paper>
  );
}
